import React from "react";
import { SimpleModulePage } from "./SimpleModulePage";

// ===== 공통 카드 래퍼 =====
const SectionCard: React.FC<{ children: React.ReactNode; className?: string }> = ({ children, className = "" }) => (
  <div className={`mx-4 mt-3 rounded-2xl bg-white shadow-sm px-4 py-3 mb-3 border border-slate-100 ${className}`}>{children}</div>
);

interface WalkPageProps {
  onBack: () => void;
  stepsCount?: number;
  stepsGoal?: number;
}

export const WalkPage: React.FC<WalkPageProps> = ({ 
  onBack,
  stepsCount = 0,
  stepsGoal = 7000,
}) => {
  const formattedSteps = stepsCount.toLocaleString();
  const formattedGoal = stepsGoal.toLocaleString();
  const remainingSteps = Math.max(0, stepsGoal - stepsCount);
  const progressPercentage = Math.min(100, (stepsCount / stepsGoal) * 100);

  return (
    <SimpleModulePage title="걷기" subtitle="(걸음수)" icon="🚶" onBack={onBack}>
      <SectionCard>
        <p className="text-[12px] font-semibold text-slate-900 mb-2">오늘 걸음</p>
        <p className="text-[24px] font-bold text-slate-900 mb-1">{formattedSteps}</p>
        <div className="w-full bg-slate-200 rounded-full h-2 mb-2">
          <div 
            className="bg-violet-600 h-2 rounded-full transition-all duration-300"
            style={{ width: `${progressPercentage}%` }}
          />
        </div>
        <p className="text-[12px] text-slate-600">
          목표까지 <span className="font-semibold text-violet-600">{remainingSteps.toLocaleString()}보</span> 남았어요 ({formattedSteps} / {formattedGoal}보)
        </p>
      </SectionCard>
    </SimpleModulePage>
  );
};
